
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance-pricing",
      function () {
        return require("private-next-pages/insurance-pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurance-pricing"])
      });
    }
  